import { StdResponse, request } from "@/global/config/request";
import { Sensor, DeviceCollectionHistory, SensorParameter, DeviceTestConnectHistory, DeviceInstallHistory, DeviceModelingDetail } from "@/global/interface/device/sensor";
import qs from "qs";

export function getSensors(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/project/${projectId}/sensors`, {
        params: {
            ...params,
        }
    })
}

export function getSensorDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensors/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createSensor(data: Sensor, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/sensors`, data, {
        params: {
            ...params,
        }
    })
}

export function createSensors(data: Sensor[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/sensors/multi`, data, {
        params: {
            ...params,
        }
    })
}

export function updateSensor(id: number, data: Sensor, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/sensors/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteSensorByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/primitives/${primitiveUuid}/delete-sensor`, {
        params: {
            ...params,
        }
    })
}

export function deleteSensor(id: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/sensors/${id}`, {
        params: {
            ...params,
        }
    })
}

export function deleteSensors(data: number[], params?: {}): Promise<StdResponse<any>> {
    return request.post(`/sensors/delete-multi`, data, {
        params: {
            ...params,
        }
    })
}

export function getSensorByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/primitives/${primitiveUuid}/sensors`, {
        params: {
            ...params,
        }
    })
}

export function queryCameraPlay(sensorId: number, paramId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensors/${sensorId}/params/${paramId}/camera-play`, {
        params: params
    })
}

export function cameraPtz(sensorId: number, paramId: number, data: any, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/sensors/${sensorId}/params/${paramId}/camera-ptz`, data, {
        params: params
    })
}


export function getImageStr(sensorParamId: number, type: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensor-params/${sensorParamId}/base64-image`, {
        params: {
            type: type,
            ...params
        }
    })
}

export function getHistoryImageStr(sensorParamId: number, type: string, time: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensor-params/${sensorParamId}/history-base64-image`, {
        params: {
            type: type,
            time: time,
            ...params
        }
    })
}


export function getHistoryVideoUrl(sensorParamId: number, projectId: string, time: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensor-params/${sensorParamId}/history-video-url`, {
        params: {
            projectId: projectId,
            time: time,
            ...params
        }
    })
}


export function sendMsgToAiServer(projectId: number, data, type?: string, paramId?: number, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/send-to-ai`, data, {
        params: {
            type: type,
            paramId: paramId,
            ...params
        }
    })
}

// 把框的范围传递
export function sendRangeToAiServer(sensorId: number, data, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/sensors/${sensorId}/send-to-ai`, data, {
        params: {
            ...params
        }
    })
}

export function findSensorParameterDtoBySensorIds(sensorIds: number[], params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensor-params`, {
        params: {
            sensorIds: sensorIds,
            ...params,
        },
        paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

export function updateSensorParameter(id: number, data: SensorParameter, params?: {}): Promise<StdResponse<any>> {
    return request.put(`/sensor-params/${id}`, data, {
        params: {
            ...params,
        },
    })
}

export function getSensorTestBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensors/${sensorId}/test`, {
        params: {
            ...params,
        },
    })
}

export function addSensorTestHistory(projectId: number, sensorId: number, data: DeviceTestConnectHistory, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/sensors/${sensorId}/test`, data, {
        params: {
            ...params,
        },
    })
}

export function deleteSensorTestBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/sensors/${sensorId}/test`, {
        params: {
            ...params,
        },
    })
}

export function deleteSensorTestByProjecdtId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/projects/${projectId}/sensor-test`, {
        params: {
            ...params,
        },
    })
}

export function getSensorCollectionBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensors/${sensorId}/collection`, {
        params: {
            ...params,
        },
    })
}

export function addSensorCollectionHistory(projectId: number, sensorId: number, data: DeviceCollectionHistory, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/sensors/${sensorId}/collection`, data, {
        params: {
            ...params,
        },
    })
}

export function deleteSensorCollectionBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/sensors/${sensorId}/collection`, {
        params: {
            ...params,
        },
    })
}

export function deleteSensorCollectionByProjecdtId(projectId: number, params?: {}): Promise<StdResponse<any>> {
    return request.delete(`/projects/${projectId}/sensor-collection`, {
        params: {
            ...params,
        },
    })
}

export function getSensorInstallBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensors/${sensorId}/installs`, {
        params: {
            ...params,
        },
    })
}

export function addSensorInstallHistory(projectId: number, sensorId: number, data: DeviceInstallHistory, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/sensors/${sensorId}/installs`, data, {
        params: {
            ...params,
        },
    })
}

export function findModelingDetailBySensorId(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensors/${sensorId}/modeling`, {
        params: {
            ...params,
        },
    })
}

export function addSensorModelingDetail(projectId: number, sensorId: number, data: DeviceModelingDetail, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/projects/${projectId}/sensors/${sensorId}/modeling`, data, {
        params: {
            ...params,
        },
    })
}

export function getMonitorParamListByParamId(paramId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/params/${paramId}/sec-params`, {
        params: {
            ...params,
        },
    })
}

export function testCameraConnect(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/sensors/${sensorId}/test-connect`, {
        params: {
            ...params,
        },
    })
}

export function getCurrentSensorTestPicture(sensorId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/sensors/${sensorId}/test-connnect-pic`, {
        params: {
            ...params,
        },
    })
}

export function updateCameraIntrinsic(sensorId: number, key: string, data: any, params?: {}): Promise<StdResponse<any>> {
    return request.post(`/sensors/${sensorId}/camera-intrinsic`, data, {
        params: {
            key: key,
            ...params,
        },
    })
}

export function getCameraConfig(sensorParamId: number, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/camera-config/${sensorParamId}`, {
        params: {
            ...params,
        }
    })
}
